import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const greaterThanField = (greaterThanControl: AbstractControl): ValidatorFn => {
  const key = 'greaterThanField';
  let subscribe = false;

  return (control: AbstractControl): ValidationErrors | null => {
    if (!subscribe) {
      subscribe = true;
      greaterThanControl.valueChanges.subscribe(() => {
        control.updateValueAndValidity();
      });
    }

    const value = control.value;

    if (!value) return null;

    if (greaterThanControl.value >= value) return { [key]: true };

    return null;
  };
}
